module.exports = __webpack_public_path__ + "static/media/icons-background-question-section.81f40b55.svg";